<template>
  <div>
    <card class="card">
      <div>
        <span class="questions-list__question-created-at text-sm">Approved </span>
        <span class="text-primary" v-if="question.approved_at"> &check; </span>
        <span class="text-danger" v-else> &times; </span>
      </div>
      <div class="questions-list__question pt-5">
        <div class="questions-list__question-score text-right">
          <span> Weight </span> {{ question.question_weight }}
          <div>
            <span class="questions-list__question-dashboard-element">Can be skipped: </span>
            <span v-if="question.can_be_skipped === '1'" class="text-primary"> &check; </span>
            <span v-else class="text-danger"> &times; </span>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="questions-list__question-text">{{ question.question_text }}</div>
          </div>
          <div class="col">
            <div class="questions-list__question-value">
              <div v-if="question.options.length > 0">
                <multiselect
                  :options="question.options"
                  placeholder="Show options"
                  track-by="id"
                  label="name"
                  :multiple="false"
                  openDirection="top"
                  :close-on-select="true"
                  :show-labels="false"
                >
                </multiselect>
              </div>
              <div v-else>
                <div v-if="question.unit">
                  <div v-if="question.unit.type === 'slider'">
                    <vue-slider :disabled="true" :marks="getDataForSlider(question.score_range)" height="12px">
                    </vue-slider>
                  </div>
                  <div v-else>
                    <fg-input
                      type="text"
                      class="-mt-12"
                      :disabled="true"
                      :label="question.unit.name"
                      :placeholder="question.unit.name"
                    >
                    </fg-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="questions-list__question-buttons">
              <router-link
                v-if="checkIfCanEditQuestions()"
                :to="{
                  name: 'Edit Question',
                  params: {
                    questionId: question.id,
                  },
                }"
              >
                <p-button icon type="success" outline class="questions-list__question-button">
                  <i class="fas fa-pen" />
                </p-button>
              </router-link>

              <p-button
                v-if="checkIfCanDeleteQuestions()"
                icon
                type="danger"
                outline
                class="questions-list__question-button"
                @click.native.prevent="openDeleteModal = true"
              >
                <i class="fas fa-trash" />
              </p-button>
            </div>
          </div>
        </div>
        <div class="row"></div>
        <div class="questions-list__question-dashboard-elements">
          <p v-if="question.created_by_company" class="questions-list__question-dashboard-element">
            Created by <a href="#">{{ question.created_by_company.name }}</a>
          </p>
        </div>

        <div class="questions-list__question-created-at-block">
          <p class="questions-list__question-created-at">Created at {{ question.created_at }}</p>
        </div>
      </div>
    </card>
    <ModalTemplate
      component-name="DeleteModal"
      :data="{
        header: 'Delete Question',
        deletion_object_text: 'this question',
        deletion_object_name: question.question_text,
      }"
      :clicked="openDeleteModal"
      @update:field="openDeleteModal = false"
      @submit="deleteQuestion($event)"
    >
    </ModalTemplate>
  </div>
</template>

<script>
import ModalTemplate from '@/components/modals/ModalTemplate';
import QuestionController from '@/controllers/Question/QuestionController';
import checkIfCanUpdateQuestions from '@/router/scopes/manage_questions/CheckIfCanUpdateQuestions';
import checkIfCanDeleteQuestions from '@/router/scopes/manage_questions/CheckIfCanDeleteQuestions';
export default {
  name: 'QuestionEdit',
  components: { ModalTemplate },
  props: {
    question: {
      type: Object,
    },
    QuestionIndex: {},
  },
  data() {
    return {
      value: null,
      visible: true,
      score: 0,
      openDeleteModal: false,
    };
  },
  methods: {
    getDataForSlider(range) {
      return {
        0: {
          label: '0%',
          labelStyle: {
            color: '#EB5E28',
          },
        },
        50: {
          label: '50%',
          labelStyle: {
            color: '#FFC20E',
          },
        },
        100: {
          label: '100%',
          labelStyle: {
            color: '#73AB6B',
          },
        },
      };
    },
    async deleteQuestion() {
      try {
        await QuestionController.destroy(this.question.id);
        this.$notify({
          type: 'success',
          title: 'Successfully deleted!',
        });
        this.$emit('deleted', this.question);
      } catch (errors) {
        Object.entries(errors.response.data).forEach((error) => {
          this.$notify({
            type: 'danger',
            text: error[1],
          });
        });
      }
    },
    checkIfCanEditQuestions() {
      return checkIfCanUpdateQuestions();
    },
    checkIfCanDeleteQuestions() {
      return checkIfCanDeleteQuestions();
    },
  },
};
</script>

<style scoped></style>
